import * as React from 'react';
import classNames from 'classnames';
import formStyle from '../style/WForm.less';
import { WActionButton } from '../../elements/WActionButton';
import DialogWrapper from '../../dialog/dialog_wrapper';
import { getKomplexRowClassname } from '../../../main/functions/getFormKey';

interface WFormFieldCustomProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    value: any;
    row?: any;
    layout?: string;
    fieldType?: string;
    disabled?: boolean;
    custom_component: () => JSX.Element;
    custom_renderer: (data: any) => string | JSX.Element;
    custom_setCloseHandler: (callback: () => void) => void; // Ultra-Tricky: Hier übergeben wir den Close-Handler!
    required?: boolean;
    readonly?: boolean;
    onValueChange(name: string, value: any): void;
}

interface WFormFieldCustomState {
    componentShowing: boolean;
}

export class WFormFieldCustom extends React.Component<WFormFieldCustomProps, WFormFieldCustomState> {
    constructor(props: any) {
        super(props);
        this.state = {
            componentShowing: false
        };
    }

    UNSAFE_componentWillMount() {
        this.props.custom_setCloseHandler(() => this.setState({ componentShowing: false }));
    }

    render() {
        const { layout, fieldType } = this.props;
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        const complexLayout = (layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen') ? true : false;
        const krCls = getKomplexRowClassname((this.props.row || {})._formKey, this.props.name) || undefined;
        return (
            <div
                className={classNames(formStyle.fieldBox, krCls)}
                style={{ ...(fieldType === 'textarea' && complexLayout ? { height: 65 } : {}) }}
            >
                {this.props.label}
                <div className={formStyle.input} style={{ display: 'flex', flexDirection: 'row' }}>
                    {this.props.custom_renderer(this.props.value)}
                    {!disabled &&
                        <div
                            className={formStyle.rowContainer}
                            style={{ justifyContent: 'space-between', marginLeft: '20px', width: '50px' }}
                        >
                            <WActionButton
                                label=''
                                action='edit'
                                style='small'
                                onAction={(action: string) => this.setState({ componentShowing: true })}
                            />
                            <WActionButton
                                label=''
                                action='delete'
                                style='small'
                                onAction={(action: string) => this.props.onValueChange(this.props.name, undefined)}
                            />
                        </div>}
                </div>
                {this.state.componentShowing &&
                    <div>
                        <DialogWrapper
                            onAfterClose={() => this.setState({ componentShowing: false })}
                        >
                            {this.props.custom_component()}
                        </DialogWrapper>
                    </div>}
            </div>
        );
    }

}
